<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="8"
          class="my-1"
      />

      <b-col
          md="6"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="z.b. Name"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
                size="sm"
                class="ml-2 btn-success"
                @click="New"
            >
              Neuer Beutzer
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            @row-clicked="Edit"
        >
          <template #cell(Online)="row">
            <div
                id="popoverAgent"
                @mouseover="OpenPopover(row.item.Online )">
            <b-avatar
                rounded
                :variant="row.item.Online != null ? 'light-success' : 'light-danger'"
            />
              {{row.item.Online}}
            </div>
          </template>
          <template #cell(Name)="row">
            {{row.item.Contact.Name}}
          </template>
          <template #cell(Address)="row">
            {{row.item.Address.Street}}, {{row.item.Address.ZipCode}} {{row.item.Address.Location}}
          </template>

          <template #cell(Email)="row">
            {{row.item.Contact.Email}}
          </template>
          <template #cell(Phone)="row">
            {{row.item.Contact.Phone}}
          </template>

          <template #cell(UserType)="data">
            <b-badge v-if="data.item.UserType == 'Administrator'" style="color: #e8e8e8; background: #980520">
              {{data.item.UserType}}
            </b-badge>
            <b-badge v-if="data.item.UserType == 'TravelAgency'" style="color: #e8e8e8; background: #009a8d">
              {{data.item.UserType}}
            </b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
          class="mb-3"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>

    <b-popover
        ref="popover"
        target="popoverAgent"
        :show.sync="popoverAgent.popoverShow"
        :disabled.sync="popoverAgent.popoverDisabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Agent</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>

        <b-table responsive="xl"
                 class="row-pointer"
                 :items="popoverAgent.popoverItems"
                 :fields="popoverAgent.popoverFields"
        />
      </div>
    </b-popover>
  </div>

</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, BPopover
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'billingList',
  components: {
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BPopover
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      popoverAgent: {
        popoverShow: false,
        popoverDisabled: false,
        popoverItems: [],
        popoverFields: [
          {
            key: 'Agent',
            label: 'Agent',
          }
        ]

      },
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'Online',
          label: 'Online',
        },
        {
          key: 'Username',
          label: 'Benutzername',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'Address',
          label: 'Adresse',
        },
        {
          key: 'Phone',
          label: 'Telefon',
        },
        {
          key: 'Email',
          label: 'E-Mail',
        },
        {
          key: 'UserType',
          label: 'Typ',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Benutzer'
    })

    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList();
        },
    )

    this.LoadList();
  },
  methods: {
    New() {
      this.$router.push({ name: 'AddUser'})
    },
    Edit(record) {
      this.$router.push({ name: 'User', params: { id: record.UserId }})
    },
    OpenPopover() {
      console.log("ads")
      this.$bvModal.show('popoverAgent')

    },
    LoadList() {

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/api/user?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/api/user/filter?filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.items.push(i)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>
